import { useState } from "react";

import { FormToggle } from "@/components/form/FormToggle";
import { Sidebar } from "@/components/sidebar";

import type { PropsWithChildren } from "react";

type Props = {
  title: string;
  checked?: boolean;
  onToggleClick: () => void;
};

export function TableToggleDisclosure({
  title,
  checked,
  onToggleClick,
  children,
}: PropsWithChildren<Props>) {
  const [open, setOpen] = useState(() => checked);

  const handleOnButtonClick = () => {
    setOpen((prevOpen) => !prevOpen);

    if (!checked) {
      onToggleClick();
    }
  };

  const handleOnToggleChange = () => {
    onToggleClick();
    setOpen(!checked);
  };

  return (
    <>
      {/* The switch sits beside the section button: a control inside a button has no name */}
      {/* The 1px bottom padding is the line box the inline button used to add below it */}
      <div className="flex w-full items-center pb-px">
        <Sidebar.SectionButton
          className="px-0 flex-1 min-w-0"
          open={open}
          aria-expanded={open}
          onClick={handleOnButtonClick}
        >
          {title}
        </Sidebar.SectionButton>
        <FormToggle checked={checked} aria-label={title} onChange={handleOnToggleChange} asInput />
      </div>
      {open && children}
    </>
  );
}
